
export enum UserScope {
    All = 'All',
    Personal = 'Personal',
    Hierarchy = 'Hierarchy',
    PersonalHierarchy = 'PersonalHierarchy'
}